/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ChannelLogoServiceRepositoryImpl, ImageHostServiceRepositoryImpl } from '../impls';
import {
    IChannelLogoServiceRepository,
    IImageAssetsService,
    IImageHostServiceRepository,
} from '../interfaces';

export class ImageAssetsService implements IImageAssetsService {
    private mChannelServiceRepo: IChannelLogoServiceRepository;

    private mImageHostServiceRepo: IImageHostServiceRepository;

    public constructor(hostOptions: { channelLogoHostUrl?: string; imageHostUrl?: string }) {
        const { imageHostUrl = '', channelLogoHostUrl = '' } = hostOptions;

        this.mChannelServiceRepo = new ChannelLogoServiceRepositoryImpl(channelLogoHostUrl);

        this.mImageHostServiceRepo = new ImageHostServiceRepositoryImpl(imageHostUrl);
    }

    /**
     * @inheritdoc
     */
    public getAtmosphericImageUrl(objectId: string): string {
        return this.mImageHostServiceRepo.getAtmosphericImageUrl(objectId);
    }

    /**
     * @inheritdoc
     */
    public getChannelLogoUrl(channelId: number): string {
        return this.mChannelServiceRepo.getChannelLogoUrl(channelId);
    }

    /**
     * @inheritdoc
     */
    public getEpisodeBannerImageUrlForVodContent(objectId: string): string {
        return this.mImageHostServiceRepo.getEpisodeBannerImageUrlForVodContent(objectId);
    }

    /**
     * @inheritdoc
     */
    public getMoviePosterImageUrl(objectId: string): string {
        return this.mImageHostServiceRepo.getMoviePosterImageUrl(objectId);
    }

    /**
     * @inheritdoc
     */
    public getPartnerSourceLogoImageUrl(objectId: string): string {
        return this.mImageHostServiceRepo.getPartnerSourceLogoImageUrl(objectId);
    }

    /**
     * @inheritdoc
     */
    public getPersonImageUrl(objectId: string): string {
        return this.mImageHostServiceRepo.getPersonImageUrl(objectId);
    }

    /**
     * @inheritdoc
     */
    public getShowcaseBannerImageUrl(objectId: string): string {
        return this.mImageHostServiceRepo.getShowcaseBannerImageUrl(objectId);
    }

    /**
     * @inheritdoc
     */
    public getShowcaseBannerImageUrlForLeague(objectId: string): string {
        return this.mImageHostServiceRepo.getShowcaseBannerImageUrlForLeague(objectId);
    }

    /**
     * @inheritdoc
     */
    public getShowcaseBannerImageUrlForTeam(objectId: string): string {
        return this.mImageHostServiceRepo.getShowcaseBannerImageUrlForTeam(objectId);
    }

    /**
     * @inheritdoc
     */
    public getShowcaseBannerImageUrlForVodContent(objectId: string): string {
        return this.mImageHostServiceRepo.getShowcaseBannerImageUrlForVodContent(objectId);
    }
}
